module.exports = __webpack_public_path__ + "img/c.498cfef0.png";